import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
* THIS IS AN AUTO GENERATED FILE, CHANGES WILL NOT APPLY
*/

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.041 5.992H14.04V4.99a1.002 1.002 0 00-2.006 0v1H11.03a1.002 1.002 0 100 2.003h1.003v1a1.002 1.002 0 002.006 0v-1h1.002a1.002 1.002 0 100-2.002m2.817-.228c-1.31-5.36-8.712-4.447-9.516-.485a21.86 21.86 0 00-.286 1.839 1 1 0 01-1 .876 1.01 1.01 0 01-1.011-1.036l.02-.766c-.328-.124-.68-.2-1.051-.2A3.01 3.01 0 002.056 9.55c.262 1.456 1.64 2.448 3.121 2.448h7.859v-.005c3.127-.05 5.618-2.967 4.822-6.229M20 6.993c0 3.833-2.953 6.942-6.964 7.002l-.03.002.03.003H5.014A5.01 5.01 0 010 8.995 5.01 5.01 0 015.014 3.99a4.97 4.97 0 011.544.267C9.523-2.717 20-.643 20 6.993m-6.964 4.989v.01c-.027.002-.053.006-.08.006.055 0 .08-.014.08-.016",
  fillRule: "evenodd"
});

var CloudPlus2Icon = function CloudPlus2Icon(_ref) {
  var className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "size"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 14",
    className: className,
    style: {
      width: size * 10,
      height: size * 10
    },
    fill: "undefined",
    focusable: "false"
  }, rest), _ref2);
};

process.env.NODE_ENV !== "production" ? void 0 : void 0;
CloudPlus2Icon.defaultProps = {
  size: 1.5
};
export default CloudPlus2Icon;